import React, { useEffect } from 'react';

// CSS
import styles from './PhaserStatus.scss';

// MODULES
import { PhaserPerformance } from './PhaserStatus.performance';
import { PhaserEvents } from './PhaserStatus.events';

const PhaserStates: React.FC<{}> = ({}) => {
    useEffect(() => {}, []);

    return (
        <div className={styles.phaser_container}>
            <PhaserPerformance />
            <PhaserEvents />
        </div>
    );
};

export default PhaserStates;
